export enum Layout {
  Desktop = '--layout-desktop',
  Mobile = '--layout-mobile',
}

export enum LayoutExtension {
  DesktopLarge = '--desktop-large',
  DesktopSmall = '--desktop-small',
  Mobile = '--mobile',
  Tablet = '--tablet',
}
